<p-chip
  styleClass="
    border border-grey 
    {{ isClickable ? 'cursor-pointer hover:shadow-lg' : '' }}
    {{ isSelected ? 'bg-primary text-white' : '' }}
    {{ colorClass[color] || 'text-textPrimary' }} 
    {{ variant === 'Tag' ? 'border-2 px-4 py-1' : '' }}
    {{ compact ? 'px-2 py-0' : 'px-4 py-1.5' }}
  "
  [removable]="removable"
  (onRemove)="onRemove($event)"
  (click)="isClickable && onClick($event)"
  removeIcon="pi pi-times text-xs"
>
  <i *ngIf="startIcon" class="{{ startIcon }} mr-2"></i>
  <app-typography
    *ngIf="!refreshTypographyComponent"
    [variant]="'secondaryHeader'"
    [component]="'p'"
    [variant]="'smallBody'"
    [gutterBottom]="false"
    overrideClass="
      {{ removable ? 'me-4' : '' }} 
      {{ colorClass[color] || 'text-textPrimary' }} 
      {{ isClickable ? 'font-bold' : '' }}" 
    [color]="isSelected ? 'white' : 'primary'"
    >{{ label ? (label | truncate: 30) : label }}</app-typography
  >
  <app-typography
    *ngIf="refreshTypographyComponent"
    variant="smallBody"
    [gutterBottom]="false"
    overrideClass="{{ isClickable ? 'font-bold' : '' }}"
  >{{ label ? (label | truncate: 30) : label }}</app-typography>
  <i *ngIf="endIconClass" class="{{ endIconClass }} ms-4" (click)="onRemove($event)"></i>
</p-chip>
